import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { isAuthenticated, logout, getEmail } from '../services/authService';
import ThemeToggle from './ThemeToggle';

function SideMenu({ items }) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const authenticated = isAuthenticated();
  const userEmail = getEmail();
  const location = useLocation();

  // Filter items based on authentication and visibility
  const filteredItems = items.filter(item => {
    if (item.is_hidden) return false;
    if (item.requiresAuth && !authenticated) return false;
    return true;
  });

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleLogout = () => {
    logout();
    setIsMenuOpen(false);
  };

  return (
    <nav className={`side-menu ${isMenuOpen ? 'open' : ''}`}>
      <div className="side-menu-header">
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <button className="menu-toggle" onClick={toggleMenu}>
            {isMenuOpen ? '✕' : '☰'}
          </button>
          <ThemeToggle />
        </div>
        {authenticated && (
          <div className="user-info" style={{fontSize: '12px', color: 'var(--text-secondary)', marginTop: '5px'}}>
            {userEmail}
          </div>
        )}
      </div>
      <div className="menu-items">
        {filteredItems.map((item, index) => (
          <Link
            key={index}
            to={item.path}
            className={location.pathname === item.path ? 'active' : ''}
          >
            {item.displayTitle || item.name}
          </Link>
        ))}
        {authenticated && (
          <button 
            onClick={handleLogout}
            style={{
              background: 'none',
              border: 'none',
              color: '#666',
              cursor: 'pointer',
              padding: '8px 16px',
              textAlign: 'left',
              width: '100%',
              fontSize: '14px'
            }}
          >
            Logout
          </button>
        )}
      </div>
    </nav>
  );
}

export default SideMenu;